import { RoleType } from 'types/RoleType';

export default class Role {
  role_id = 0;

  customer_id = '';

  customer_name = '';

  role_type: RoleType = 'Client';
}
